/* unplugin-vue-components disabled */import { render } from "./AppMain.vue?vue&type=template&id=be035208&scoped=true"
const script = {}

import "./AppMain.vue?vue&type=style&index=0&id=be035208&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be035208"]])

export default __exports__